const e = {
  public: {
    authData: "auth0",
    referralURLsearch: "referral_url_search",
    // location.search after redirect from stenn.com
    perPageCount: "per_page_count"
  },
  private: {
    selectedSupplierData: "selected_supplier_data",
    forgotPasswordEmail: "forgot_password_email",
    otpCode: "otp_code"
  }
};
export {
  e as LOCAL_STORAGE_KEYS
};
//# sourceMappingURL=constants30.mjs.map
